import React from 'react'
import { Space, Switch, Select } from 'antd'
import { useCacheService, getServicesForSelect } from '../../../../hooks/cache/service'

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const Filters = (props) => {
  const { filters } = props
  const { data: servicesRaw } = useCacheService()
  const isActive = filters ? filters.active == 1 : false
  const serviceId = filters ? (filters.serviceId ? parseInt(filters.serviceId) : undefined) : undefined

  const serviceList = getServicesForSelect(servicesRaw)

  return (
    <>
      <Space size='small'>
        <Switch
          checked={isActive}
          size='small'
          onChange={(bool) => props.onUpdateFilters({ active: bool ? 1 : 0 })}
        />{' '}
        Actives
      </Space>
      <br />
      <br />
      <Space size='small'>
        <Select
          placeholder='Service'
          allowClear
          name='Service'
          size='small'
          showSearch
          options={serviceList}
          filterOption={_filter}
          style={{ minWidth: '150px' }}
          value={serviceId}
          onChange={(e) => {
            props.onUpdateFilters({ serviceId: e ? e : undefined })
          }}
        />
      </Space>
    </>
  )
}

Filters.defaultProps = {
  filters: {},
  onUpdateFilters: async () => {}
}

export default Filters
